import React from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

type BannerType = 'normal' | 'warning' | 'success' | 'danger';

type BannerProps = {
  title: string;
  message: string;
  type?: BannerType;
  className?: string;
};

const severityMap: Record<BannerType, 'info' | 'warning' | 'success' | 'error'> = {
  normal: 'info',
  warning: 'warning',
  success: 'success',
  danger: 'error',
};

const TopBanner: React.FC<BannerProps> = ({
  title,
  message,
  type = 'normal',
  className,
}) => {
  return (
    <Alert
      severity={severityMap[type]}
      className={className}
      sx={{
        py: 0.5,
        px: 2,
        borderRadius: '12px',
        alignItems: 'center',
        '& .MuiAlert-message': {
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          width: '100%',
        },
      }}
    >
      <Typography component="span" sx={{ fontWeight: 600, fontSize: '0.875rem' }}>
        {title}
      </Typography>
      <Box component="span" sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
        - {message}
      </Box>
    </Alert>
  );
};

export default TopBanner;

